
<template>
  <div class="mx-auto" style="width: 80%" >

	<b-modal id="view-testuser-modal" size='lg' scrollable v-bind:title="title" cancel-only>
		<b-tabs content-class="mt-3">

			<b-tab title="LDAP" active>
                <LdapDetails :ldapAttributes='this.user.ldap'/>
			</b-tab>

			<b-tab title="UPS" :disabled="!isUps">
				<UpsDetails :upsAttributes='this.user.ups'/>
			</b-tab>

			<b-tab title="SIS" disabled/>
		</b-tabs>
    </b-modal>

     

  </div>

</template>

<script>
/* eslint-disable no-alert, no-console */

// import {FETCH_CAS_TICKET, FETCH_JWT} from '../../store/actions/auth'
// import {CREATE_TEST_USER, DELETE_TEST_USER} from '../../store/actions/testusers'
// import CreateTestuser from './CreateTestuser'
// import ViewTestuser from './ViewTestuser'
  // FETCH_JWT,
  // ON_SUCCESSFUL_AUTHORIZATION,
  // NOTIFY_AUTH_FAILURE,
  // LOGOUT} 

import LdapDetails from './LdapDetails'
import UpsDetails from './UpsDetails'

export default {
	name: 'ViewTestuser',
	components: {
		LdapDetails,
		UpsDetails
	},
	data() {
		return {
			fields: ["Attribute", "Value"],
			// showuser: true
		}
	},
	computed: {
		ldapRows: function() {
			return (this.user.ldap) ? Object.entries(this.user.ldap).sort().map(([k,v]) => ({attribute: k, value: v})) : []
		},
		upsRows: function() {
			return (this.user.ups) ? this.user.ups : {}
		},
		isUps: function() {
			return this.user.isUps
		},
		title: function() {
			return (this.user.ldap) ? `View Details (${this.user.ldap.uid})` : `Testuser empty!`
		}
	},
	props: {
		user: Object
	}
}
</script>

